// extracted by mini-css-extract-plugin
export default {"main":"style_main__EUZ58","switch":"style_switch__hIExy","slider":"style_slider__l4ghW","text":"style_text__wfZxO"};